// Dependency
import React from 'react';
import { Link } from 'gatsby';

// Styles
import * as styles from './upsell.module.scss';
import { useCart } from '../../../contexts/cart-context';

// Assets
import atc from "../../../images/medical_services.svg"

// Services
import UtilsService from "../../../services/utils.service";

// Internationalization
import { useTranslation } from 'react-i18next';
import * as ProductCardStyles from "../../cards/product-card.module.scss";

// Template
const UpsellCard = ({toggleLoad, product, prodId, country}) => {

    //TODO map correct price in upsell swiper
    const {addToCart} = useCart();

    const currencyMap = {
        EUR: "eu",
        SEK: "se",
        DKK: "dk",
        NOK: "no",
        USD: "us"
    }

    /* const priceFilter = item.prices.filter((priceObject) => {
         if (priceObject.price && currencyMap[priceObject.price.currency.name] === country) return true;
     })*/

    // Translation Function
    const { t } = useTranslation();

    return (
        <div className={styles.cdUpsellCard}>
            <button
                className={`${styles.cdUpsellAtc}`}
                onClick={() => {addToCart(product.items[0].item, 'checkout_upsell', product)}}
                /*onClick={() => {
                    addToCart(`${item.displayItems[0].id}-${prodId}`, item)
                }}*/>
                <img src={atc} alt={"Add To Cart"}/>
            </button>
            <Link to={`/${UtilsService.getLocaleFromUrl().country}/${t('slug.product')}/${product.uri}`}
                  className={`${styles.cdUpsellCardImg} cd-background-img`}>
                {product.media && product.media.standard && <img src={product.media.standard[0]} alt={product.name} />}
            </Link>
            <div className={styles.cdUpsellCardContent}>
                <h3 className={``}>{product.name}</h3>
                <div className={`${styles.cdUpsellCardPrice}`}>
                    <p className={product && product.priceBeforeDiscountAsNumber !== product.priceAsNumber ? 'cd-price-red' : ''}>{product.price}</p>
                    {product && product.priceBeforeDiscountAsNumber !== product.priceAsNumber ?
                        <p className={` cd-product-price-original`}>
                            <del className="cd-product-price-value">{product && product.priceBeforeDiscount}</del>
                        </p>: ''}
                </div>

                {/*
                <p>{`${priceFilter.length > 0 && priceFilter[0].price.value} ${priceFilter.length > 0 && priceFilter[0].price.currency.name}`}</p>
*/}
            </div>
        </div>
    );
};

export default UpsellCard;